<template>
  <table class="table table-borderless">
    <thead>
      <tr>
        <th scope="col-1">
          OS/Pedidos
        </th>
        <th scope="col-1">
          Tipo
        </th>
        <th scope="col-2">
          Selo
        </th>
        <th scope="col-1">
          Valor
        </th>
        <th scope="col">
          Status pagamento
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(pedido, index) in propMensalista.pedidos"
          :key="pedido.cx_pedido_id"
          :class="index % 2 === 0 ? 'linha-par' : 'linha-impar'">
        <th scope="row d-flex align-items-center"
            class="col-1"
            @click="openOs(pedido)">
          {{ pedido.ordemServico ?
            pedido.ordemServico.numero : 
            pedido.lancamentosAvulso ?
              pedido.lancamentosAvulso.cx_lancamento_id :'' }}
        </th>
        <td class="col-1"
            @click="openOs(pedido)">
          {{ pedido.tipo_pedido }}
        </td>
        <td class="col-2">
          <TableSelo v-if="(pedido.ordemServico && pedido.ordemServico.itens.length && pedido.ordemServico.itens[0].seloItemOs.length)"
                     :prop-selo="pedido.ordemServico.itens ?
                       pedido.ordemServico.itens[0].seloItemOs[0] ? pedido.ordemServico.itens[0].seloItemOs[0] : null : null"
                     :prop-mensalista="true" />
          <span v-else
                :id="pedido.cx_pedido_id">
            ---
          </span>
        </td>
        <td class="col-1">
          <input v-money="money"
                 :value="pedido.ordemServico ? pedido.ordemServico.valor_total :
                   pedido.lancamentosAvulso ? pedido.lancamentosAvulso.valor_total: ''"
                 readonly
                 class="valor-text"
                 @click="showInfos(item)">
        </td>
        <td class="col">
          {{ pedido.status_pg }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
  import { VMoney } from 'v-money'
  import TableSelo from '../../FrenteDeCaixaPendentes/TableSelo.vue'

  export default ({
    name: 'TabelaMensalista',
    components: {
      TableSelo
    },
    directives: {
      money: VMoney
    },
    props: {
      propMensalista: { type: Object, default: null}
    },
    data () {
      return {
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2, 
          masked: false
        },
      }
    },
    methods: {
      openOs (pedido) {
        this.$router.push({ name: 'ordem_servico_editar', params: { id: pedido.ordemServico.ordem_servico_id } })
      }
    }
  })
</script>

<style scoped>
.valor-text {
  background-color: transparent;
  border: none;
  outline: none;
  
}
.linha-par {
  background: #EAEAEA;
}
</style>
